import { createSlice } from '@reduxjs/toolkit';
import {
  getTaxonomyList, getTaxonomyDetails, getTaxonomyReport, getTaxonomyExpandedReport,
} from './featureTaxonomyAction';

export const taxonomyListSlice = createSlice({
  name: 'taxonomyList',
  initialState: {
    loading: false,
    error: null,
    data: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTaxonomyList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTaxonomyList.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload.taxonomyList;
      state.error = null;
    });
    builder.addCase(getTaxonomyList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const taxonomyDetailsSlice = createSlice({
  name: 'taxonomyDetails',
  initialState: {
    loading: false,
    error: null,
    data: {
      name: '',
      tree: [],
      levels: [],
    },
  },
  reducers: {
    resetTaxonomyDetails: (state) => {
      state.loading = false;
      state.error = null;
      state.data = {
        name: '',
        tree: [],
        levels: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTaxonomyDetails.pending, (state) => {
      state.loading = true;
      state.data = {
        name: '',
        tree: [],
        levels: [],
      };
    });
    builder.addCase(getTaxonomyDetails.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = {
        name: payload.taxonomyDetails?.name,
        tree: payload.taxonomyDetails?.tree,
        levels: payload.taxonomyDetails?.level,
      };
      state.error = null;
    });
    builder.addCase(getTaxonomyDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = {
        name: '',
        tree: [],
        levels: [],
      };
    });
  },
});

export const taxonomyReportSlice = createSlice({
  name: 'taxonomyReport',
  initialState: {
    loading: false,
    error: null,
    data: [],
    count: 0,
    activeAccount: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTaxonomyReport.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.count = 0;
      state.activeAccount = 0;
    });
    builder.addCase(getTaxonomyReport.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload.responseArray ?? payload.nodeList ?? [];
      state.count = payload.count ?? 0;
      state.activeAccount = payload.activeAccount ?? 0;
      state.error = null;
    });
    builder.addCase(getTaxonomyReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = [];
      state.count = 0;
      state.activeAccount = 0;
    });
  },
});

export const taxonomyExpandedReportSlice = createSlice({
  name: 'taxonomyExpandedReport',
  initialState: {
    loading: false,
    error: null,
    data: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTaxonomyExpandedReport.pending, (state) => {
      state.loading = true;
      state.data = [];
    });
    builder.addCase(getTaxonomyExpandedReport.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload ?? [];
      state.error = null;
    });
    builder.addCase(getTaxonomyExpandedReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = [];
    });
  },
});

export const { resetTaxonomyDetails } = taxonomyDetailsSlice.actions;
